import React, { useEffect, useState } from "react";
import axios, { API_BASE_URL } from "../api/axios";
import ImageLoader from "../common/ImageLoader";
import "./Events.css";

const Events = () => {
  const [years, setYears] = useState([]);
  const [selectedYearId, setSelectedYearId] = useState(null);
  const [loading, setLoading] = useState(true);

  const BASE_URL = API_BASE_URL;

  useEffect(() => {
    fetchYears();
  }, []);

  const fetchYears = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/events");
      setYears(res.data || []);

      if (res.data && res.data.length > 0) {
        setSelectedYearId(res.data[0].id);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const selectedYear = years.find((year) => year.id === selectedYearId);
  const eventsToDisplay = selectedYear?.Events || [];

  const formatPath = (path) => {
    if (!path) return "";
    return `${BASE_URL}/${path.replace(/\\/g, "/")}`;
  };

  const handleCardClick = (reportPath) => {
    if (reportPath) {
      window.open(formatPath(reportPath), "_blank");
    }
  };

  if (loading) {
    return (
      <div className="events-page loading-page">
        <div className="loading-spinner"></div>
        <p>Loading events history...</p>
      </div>
    );
  }

  return (
    <section id="events-page" className="events-page">
      <div className="events-container">
        {/* Header Section */}
        <div className="section-header">
          <span className="section-tag">✦ TIMELINE &amp; MILESTONES</span>
          <h1 className="section-main-title">Our Chapter Events</h1>
          <p className="section-description">
            Explore the exciting workshops, hackathons, seminars, and technical
            competitions organized by the DIET ACM Student Chapter.
          </p>

          {/* Academic Year Filter Pills */}
          {years.length > 0 && (
            <div className="year-filter-wrapper">
              <div className="year-buttons">
                {years.map((year) => (
                  <button
                    key={year.id}
                    className={`year-button ${selectedYearId === year.id ? "active" : ""}`}
                    onClick={() => setSelectedYearId(year.id)}
                  >
                    <span>{year.label}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Events Grid */}
        {eventsToDisplay.length > 0 ? (
          <div className="events-grid">
            {eventsToDisplay.map((event) => (
              <article
                className="event-card glass-panel glow-on-hover"
                key={event.id}
                onClick={() => handleCardClick(event.reportPath)}
                title={event.reportPath ? "Click to view event report PDF" : ""}
              >
                <div className="event-image-wrapper">
                  <ImageLoader
                    src={formatPath(event.posterPath)}
                    alt={event.name}
                    className="event-image"
                  />
                  {event.reportPath && (
                    <div className="event-report-badge">
                      <i className="far fa-file-pdf"></i>
                      <span>Report Available</span>
                    </div>
                  )}
                </div>

                <div className="event-content">
                  <div className="event-meta">
                    {event.eventType && (
                      <span className="event-type-badge">{event.eventType}</span>
                    )}
                    {event.date && (
                      <span className="event-date-badge">
                        <i className="far fa-calendar-alt"></i> {event.date}
                      </span>
                    )}
                  </div>

                  <h2 className="event-title">{event.name}</h2>
                  <p className="event-description">{event.description}</p>

                  {event.reportPath && (
                    <div className="event-card-action">
                      <span>
                        View Event Report <i className="fas fa-external-link-alt"></i>
                      </span>
                    </div>
                  )}
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="no-events glass-panel">
            <i className="far fa-calendar-times no-events-icon"></i>
            <h3>No Events Recorded</h3>
            <p>No events found for this academic year ({selectedYear?.label}).</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Events;